import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Chip, Popover, Box, Typography } from "@material-ui/core";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import { listTags } from "../../services/tags";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
  tagButton: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 4,
    padding: "4px 8px",
    borderRadius: 16,
    border: "1px solid #ccc",
    fontSize: "0.75em",
    color: "#666",
    marginRight: 8,
    alignSelf: "center",
  },
  popover: {
    padding: 16,
    minWidth: 200,
    maxWidth: 300,
  },
  tagChip: {
    margin: 4,
    cursor: "pointer",
  },
  selectedTags: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    alignSelf: "center",
    marginRight: 8,
  }
}));

const TagSelector = ({ tags: entityTags, onSync }) => {
  const classes = useStyles();
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const data = await listTags();
        setTags(data);
      } catch (err) {
        toastError(err);
      }
    };
    fetchTags();
  }, []);

  useEffect(() => {
    if (entityTags) {
      setSelectedTags(entityTags.map(t => t.id));
    }
  }, [entityTags]);

  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggleTag = async (tagId) => {
    const newSelected = selectedTags.includes(tagId)
      ? selectedTags.filter(id => id !== tagId)
      : [...selectedTags, tagId];

    setSelectedTags(newSelected);

    try {
      await onSync(newSelected);
    } catch (err) {
      toastError(err);
    }
  };

  const selectedTagObjects = tags.filter(t => selectedTags.includes(t.id));

  return (
    <>
      <div className={classes.selectedTags}>
        {selectedTagObjects.map(tag => (
          <Chip
            key={tag.id}
            label={tag.name}
            size="small"
            className={classes.tagChip}
            style={{ backgroundColor: tag.color, color: "#fff" }}
            onClick={handleOpen}
          />
        ))}
        {selectedTagObjects.length === 0 && (
          <div className={classes.tagButton} onClick={handleOpen}>
            <LocalOfferIcon style={{ fontSize: 14 }} />
            <span>Etiquetas</span>
          </div>
        )}
      </div>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box className={classes.popover}>
          <Typography variant="subtitle2" gutterBottom>
            Seleccionar etiquetas
          </Typography>
          {tags.map(tag => (
            <Chip
              key={tag.id}
              label={tag.name}
              size="small"
              className={classes.tagChip}
              style={{
                backgroundColor: selectedTags.includes(tag.id) ? tag.color : "#eee",
                color: selectedTags.includes(tag.id) ? "#fff" : "#333",
              }}
              onClick={() => handleToggleTag(tag.id)}
            />
          ))}
          {tags.length === 0 && (
            <Typography variant="caption" color="textSecondary">
              No hay etiquetas. Créalas en Configuración.
            </Typography>
          )}
        </Box>
      </Popover>
    </>
  );
};

export default TagSelector;
